import { useStorage } from '#pplx/frontend/browser-storage/hooks/internal/useStorage.js';
import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
/**
 * A custom React hook that synchronizes state with localStorage using SafeLocalStorage.
 *
 * @template T - The type of the stored value
 * @param {string} key - The localStorage key
 * @param {T | (() => T)} initialValue - The initial value if no value exists in localStorage
 * @param {StorageOptions} options - `broadcast` (sync across hooks in the tab, default true) and
 *   `global` (read/write the un-namespaced cross-account key instead of the active-account one,
 *   default false)
 * @returns {[T, (value: T | ((prev: T) => T)) => void]} A tuple containing the current value and a setter function and a remove function
 *
 * @example
 * const [theme, setTheme] = useLocalStorage<string>('theme', 'light');
 * setTheme('dark'); // Updates both state and localStorage
 *
 * @example
 * // A per-browser value shared across all signed-in accounts:
 * const [enabled] = useLocalStorage('pplx.some-device-flag', false, { global: true });
 */
export const useLocalStorage = (key, initialValue, options = {}) => {
    return useStorage(key, initialValue, SafeLocalStorage, options);
};
//# sourceMappingURL=useLocalStorage.js.map